import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { DocumentViewerComponent } from '../support/document-viewer/document-viewer.component';
import { DocViewerConfig } from '../support/models/doc-viewer-config.model';

@Component({
  selector: 'app-documenttype',
  templateUrl: './documenttype.component.html',
  styleUrls: ['./documenttype.component.scss'],
})
export class DocumenttypeComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private readonly appService: AppService,
    public router: Router,
    private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService,
    public message: messageService,
    private readonly elem: ElementRef
  ) { }

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddModuleValue: any = null;
  oddCRProcess: any = null;
  oddExpiryInUnit: any = null;
  oddTemplate: any = null;
  oddReportHeaderTemplateId: any = null;
  printPagePositionsList: any = [];
  dropdownForHeaderTemplate: any = [];
  ngOnInit(): void {
    this.PageName = 'Document Type';
    this.dropDownForModules = JSON.parse(
      sessionStorage.getItem('dropDownForModules') || '{}'
    );
    this.dropDownForexpiryUnits = JSON.parse(
      sessionStorage.getItem('expiryUnits') || '{}'
    );
    this.dropDownFornonorgModulesData = JSON.parse(
      sessionStorage.getItem('nonorgModulesData') || '{}'
    );

    this.dataTypeCRProcess = JSON.parse(
      sessionStorage.getItem('docTypeCRProcess') || '{}'
    );
    console.log(this.dataTypeCRProcess);
    this.selectBoxeForCRProcess();
    this.selectBoxeForModuleValue();
    this.fetchDownloadTemplates();

    this.appService
      .getDmsDocumentTemplateVwDetails()
      .subscribe((response: any) => {
        this.dropDownForTemplates = response;
        this.selectBoxForTemplate();
      });
    this.appService
      .getNonOrgCodeListsByGroupName(

        'DOCUMENT_TYPE_STAGES'
      )
      .subscribe((response: any) => {
        this.docTypeStageList = response;
        this.selectBoxeFordocTypeStageValue();
        this.selectBoxForAmendmentListOfStages();
        this.selectBoxForexpiryInUnit();
      });
    this.appService
      .getNonOrgCodeListsByGroupName(

        'PRINT_DOCUMENT_SECTIONS'
      )
      .subscribe((response: any) => {
        this.printPagePositionsList = response;
        this.selectBoxForPrintPagePosition();
      });
    this.appService
      .getOneQmsNonorgModuleStagesDetails(
        'DOCS_WITHDRAWAL'
      )
      .subscribe((response: any) => {
        this.docWithdrawlStageList = response;
        this.selectBoxForObsoleteListOfStages();
      });
    this.appService
      .getOneQmsNonorgModuleStagesDetails(

        'DOCS_EXTENSION'
      )
      .subscribe((response: any) => {
        this.docExtensionStageList = response;
        this.selectBoxForExtensionListOfStages();
      });

    this.appService
      .getOneQmsNonorgModuleStagesDetails(

        'DOCS_DESTRUCTION'
      )
      .subscribe((response: any) => {
        this.docDestructionListOfStatesList = response;
        this.selectBoxForDestructionListOfStates();
      });
    this.appService
      .getAllDocumentReportHeaderTemplates()
      .subscribe((data: any) => {
        this.dropdownForHeaderReportTemplate = [];
        for (const item of data) {
          if (
            item.templateName !== '' &&
            item.templateName !== null &&
            item.templateName !== undefined
          ) {
            this.dropdownForHeaderReportTemplate.push({
              valueExp: item.templateId,
              displayExp: item.templateName,
            });
          }
        }
      });
  }

  downloadTemplateList: any[] = [];
  selectedDownloadTemplate: number | null = null;
  docWithdrawlStageList: any = [];
  docExtensionStageList: any = [];
  docDestructionListOfStatesList: any = [];
  selectCRProcess: any = null;
  CRProcessValueDropdown: any = [];
  selectBoxeForCRProcess() {
    this.CRProcessValueDropdown = [];

    for (const process of this.dataTypeCRProcess) {
      this.CRProcessValueDropdown.push({
        valueExp: process.codelistCode,
        displayExp: process.codelistName,
      });
    }
  }

  fetchDownloadTemplates() {

    this.appService.getAllDownloadTemplates().subscribe({
      next:
        (data: any) => {
          this.downloadTemplateList = data.map((item: any) => ({
            id: item.templateId,
            name: item.templateName,
            fullData: item
          }));
        }, error:
        (error) => {
          console.error('Error fetching download templates', error);
        }
    }
    );
  }

  getSelectedDownloadTemplate(): { id: number; name: string } | null {
    if (!this.selectedDownloadTemplate) {
      return null;
    }

    const match = this.downloadTemplateList.find(
      (t: any) => t.id == this.selectedDownloadTemplate
    );

    return match
      ? { id: match.id, name: match.name }
      : null;
  }



  documentNameFormatValidationIcon: any;

  modulevalue: any = null;
  selectBoxeForModuleValue() {
    this.moduleValueDropdown = [];
    for (let i = 0; i < this.dropDownForModules.length; i++) {
      if (this.dropDownForModules[i].codelistName != 'Trainings') {
        this.moduleValueDropdown = this.moduleValueDropdown.concat({
          valueExp: this.dropDownForModules[i].codelistCode,
          displayExp: this.dropDownForModules[i].codelistName,
        });
      }
      if (i == this.dropDownForModules.length - 1) {
        this.selectedMainmoduleValue = 'DOCS';
        this.modulevalue = this.selectedMainmoduleValue;
        this.appService
          .getFlexifieldSetupByModuleList(
            this.selectedMainmoduleValue,
            null
          )
          .subscribe((response: any) => {
            this.flexifieldSetupList = response;
            this.selectBoxeForFlexifieldValue();
          });
        if (!this.selectedMainmoduleValue) {
          this.selectedMainmoduleValue = 'DOCS';
        }
        this.getcallMethod();
      }
    }
  } selectBoxeFordocTypeStageValue() {
    this.docTypeValueDropdown = [];
    for (const stage of this.docTypeStageList) {
      this.docTypeValueDropdown.push({
        valueExp: stage.codelistName,
        displayExp: stage.codelistName,
      });
    }
  }

  selectBoxeForFlexifieldValue() {
    this.flexifieldsValueDropdown = [];
    for (const field of this.flexifieldSetupList) {
      if (field.isActive === 'Y') {
        this.flexifieldsValueDropdown.push({
          valueExp: field.fieldId,
          displayExp: field.fieldName,
        });
      }
    }
  }

  selectedAmendmentListOfStages: any = [];
  amendmentListOfStagesDropdown: any = [];
  selectBoxForAmendmentListOfStages() {
    this.amendmentListOfStagesDropdown = [];
    for (const stage of this.docTypeStageList) {
      this.amendmentListOfStagesDropdown.push({
        valueExp: stage.codelistName,
        displayExp: stage.codelistName,
      });
    }
  }

  additionalPagePrintPositionDropdown: any = [];
  selectBoxForPrintPagePosition() {
    this.additionalPagePrintPositionDropdown = [];
    for (const position of this.printPagePositionsList) {
      this.additionalPagePrintPositionDropdown.push({
        valueExp: position.codelistCode,
        displayExp: position.codelistName,
      });
    }
  }

  selectedExtensionListOfStages: any = [];
  extensionListOfStagesDropdown: any = [];
  selectBoxForExtensionListOfStages() {
    this.extensionListOfStagesDropdown = [];
    for (const stage of this.docExtensionStageList) {
      this.extensionListOfStagesDropdown.push({
        valueExp: stage.oneQmsNonorgModuleStagesPk.stageName,
        displayExp: stage.oneQmsNonorgModuleStagesPk.stageName,
      });
    }
  }

  destructionListOfStatesSelected = false;
  selectedDestructionListOfStates: any = [];
  destructionListOfStatesDropdown: any = [];
  selectBoxForDestructionListOfStates() {
    this.destructionListOfStatesDropdown = [];
    for (const state of this.docDestructionListOfStatesList) {
      this.destructionListOfStatesDropdown.push({
        valueExp: state.oneQmsNonorgModuleStagesPk.stageName,
        displayExp: state.oneQmsNonorgModuleStagesPk.stageName,
      });
    }
  }
  destructionListOfStatesSearchText: string = '';
  onDestructionListOfStatesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.destructionListOfStatesSelected =
          this.destructionListOfStatesDropdown.length ==
          this.selectedDestructionListOfStates.length;
      });
    }
  }


  selectedObsoleteListOfStages: any = [];
  obsoleteListOfStagesDropdown: any = [];
  selectBoxForObsoleteListOfStages() {
    this.obsoleteListOfStagesDropdown = [];

    for (const stage of this.docWithdrawlStageList) {
      this.obsoleteListOfStagesDropdown.push({
        valueExp: stage.oneQmsNonorgModuleStagesPk.stageName,
        displayExp: stage.oneQmsNonorgModuleStagesPk.stageName,
      });
    }
  }

  selectedexpiryInUnit: any = null;
  reportHeaderTemplateId: any = null;
  expiryInUnitDropdown: any = [];
  selectBoxForexpiryInUnit() {
    this.expiryInUnitDropdown = [];

    for (const unit of this.dropDownForexpiryUnits) {
      this.expiryInUnitDropdown.push({
        valueExp: unit.codelistCode,
        displayExp: unit.codelistName,
      });
    }
  }
  selectedTemplate: any = null;
  selectedReportHeaderTemplateId: any = null;
  dropDownForTemplates: any = [];
  dropDownForReportHeaderTemplateId: any = [];
  TemplateDropdown: any = [];
  dropDownFornonorgModulesData: any = [];
  dataTypeCRProcess: any = [];
  selectBoxForTemplate() {
    this.TemplateDropdown = [];

    for (const template of this.dropDownForTemplates) {
      this.TemplateDropdown.push({
        valueExp: template.templateId,
        displayExp: template.templateName,
      });
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0);
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0);
  }


  mainModulesearchTxt: any;

  onMainModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.modulevalue = item.valueExp;
        this.getcallMethod();
      } else {
        this.modulevalue = null;
      }
    }
  }


  modulesearchTxt: any;

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectModule = item.valueExp;
        this.selectModuleName = item.valueExp;
      }
    }
  }


  @ViewChild('listofStages') listofStages: MatSelect;
  @ViewChild('poAsdocumentTypes') poAsdocumentTypes: MatSelect;
  @ViewChild('listofFlexifields') listofFlexifields: MatSelect;
  @ViewChild('extnListOfStages') extnListOfStages: MatSelect;
  @ViewChild('withdrawListOfStages') withdrawListOfStages: MatSelect;
  @ViewChild('destructionListOfStates') destructionListOfStates: MatSelect;



  isListofStagesSelected = false;
  isPoAsdocumentTypesSelected = false;
  isListofFlexifieldsSelected = false;
  isExtnListOfStagesSelected = false;
  isWithdrawListOfStagesSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'listofStages') {
      if (this.isListofStagesSelected)
        this.listofStages.options.forEach((item: MatOption) => item.select());
      else
        this.listofStages.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'poAsdocumentTypes') {
      if (this.isPoAsdocumentTypesSelected)
        this.poAsdocumentTypes.options.forEach((item: MatOption) =>
          item.select()
        );
      else
        this.poAsdocumentTypes.options.forEach((item: MatOption) =>
          item.deselect()
        );
    } else if (value == 'listofFlexifields') {
      if (this.isListofFlexifieldsSelected)
        this.listofFlexifields.options.forEach((item: MatOption) =>
          item.select()
        );
      else
        this.listofFlexifields.options.forEach((item: MatOption) =>
          item.deselect()
        );
    } else if (value == 'extnListOfStages') {
      if (this.isExtnListOfStagesSelected)
        this.extnListOfStages.options.forEach((item: MatOption) =>
          item.select()
        );
      else
        this.extnListOfStages.options.forEach((item: MatOption) =>
          item.deselect()
        );
    } else if (value == 'withdrawListOfStages') {
      if (this.isWithdrawListOfStagesSelected)
        this.withdrawListOfStages.options.forEach((item: MatOption) =>
          item.select()
        );
      else
        this.withdrawListOfStages.options.forEach((item: MatOption) =>
          item.deselect()
        );
    } else if (value == 'destructionListOfStates') {
      if (this.destructionListOfStatesSelected)
        this.destructionListOfStates.options.forEach((item: MatOption) =>
          item.select()
        );
      else
        this.destructionListOfStates.options.forEach((item: MatOption) =>
          item.deselect()
        );
    }
  }

  onReportHeaderTemplateSelect(event: any, item: any) { }

  reportHeaderTemplateSearchText: string = '';
  listofStagesSearchText: string = '';
  onDocTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isListofStagesSelected =
          this.docTypeValueDropdown.length == this.selectDocTypeName.length;
      });
    }
  }

  isProcessing: boolean = false;
  PageName: any;
  showingResultsText = 'Showing results';
  displayingClaimsText = 'Displaying claims';
  rowText = 'Rows';
  showingRowsText = 'Showing rows';
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  documentTypeCall: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  visibleEditButton: boolean;
  dropDownForModules: any;
  dropDownForexpiryUnits: any;
  popupTitle: any;
  flexifieldSetupList: any;
  docTypeData: any;
  docTypeStageList: any;
  docTypeValueDropdown: any;
  selectDocTypeName: any;
  selectedDocTypeCodeValue: any;
  selectedDocTypeNameValue: any;

  selectModule: any;
  selectModuleName: any;
  selectedmoduleValue: any;
  selectedMainmoduleValue: any = null;
  moduleValueDropdown: any = [];

  selectFlexifield: any;
  selectFlexifieldName: any;
  selectFlexifieldsValue: any;
  flexifieldsValueDropdown: any;

  selectedPossibleAssDoc: any = [];
  possibleAssDocDropdown: any;
  /*   onFlexifieldsSelect(item: any) {
      
      this.selectFlexifield = item.valueExp;
      this.selectFlexifieldName = item.displayExp;
    };
    onFlexifieldsRemoved(item: any) { }; */

  listofFlexifieldsSearchText: string = '';
  onFlexifieldsSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectFlexifield = item.valueExp;
        this.selectFlexifieldName = item.displayExp;
      }
      setTimeout(() => {
        this.isListofFlexifieldsSelected =
          this.flexifieldsValueDropdown.length ==
          this.selectFlexifieldsValue.length;
      });
    }
  }

  /*   onPossibleAssDocSelect(item: any) {
    }

    onPossibleAssDocRemoved(item: any) { }; */
  poAsdocumentTypesSearchText: string = '';
  onPossibleAssDocSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isPoAsdocumentTypesSelected =
          this.possibleAssDocDropdown.length ==
          this.selectedPossibleAssDoc.length;
      });
    }
  }
  extnListOfStagesSearchText: string = '';
  onExtnListofStagesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isExtnListOfStagesSelected =
          this.extensionListOfStagesDropdown.length ==
          this.selectedExtensionListOfStages.length;
      });
    }
  }



  withdrawListOfStagesSearchText: string = '';
  onWithdrawListOfStagesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isWithdrawListOfStagesSelected =
          this.obsoleteListOfStagesDropdown.length ==
          this.selectedObsoleteListOfStages.length;
      });
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(
      this.documentTypeCall.length,
      page,
      this.perPage,
      targetpage
    );
    this.pagedItems = this.documentTypeCall.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const docType of this.documentTypeCall) {
      docType.childCheckBoxs = isChecked;
    }
  }
  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.documentTypeCall[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.DOCUMENT_TYPE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.documentTypeCall.some(
      (list: any) => list.childCheckBoxs
    );
    this.previousIdx = idx;
  }
  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-col1'
    );
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    });

    let elements2 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-row1'
    );
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == lengthOfColumns - 1) {
        index2 = 0;
      } else {
        index2++;
      }
    });
  }

  onClick(event: any) {

  }

  getcallMethod() {
    this.isProcessing = true;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.documentTypeCall = [];
    const data = {
      gridName: 'DOCUMENT_TYPES',
    };

    this.appService.getDynamicGridHeaders(data).subscribe(
      {
        next: (response: any) => {
          response.orderByClause ??= '';

          this.makeStickyColumns = response.fixedFieldCnt;

          const data1: any = {
            gridName: 'DOCUMENT_TYPES',
            tableOrViewName:
              response.tableOrViewName ?? '',
            columnsList: response.columnsList ?? '',
            fieldLabelsList:
              response.fieldLabelsList ?? '',
            invisibleColumn:
              response.invisibleColumn ?? '',
            orderByClause:
              response.orderByClause ?? '',
            fieldSizeList:
              response.fieldSizeList ?? '',
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            status: this.statusCodeValue,
            codelistGroup: null,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || '',
            blobColumnlist: response.bloblist || '',
          };

          if (this.selectedMainmoduleValue) {
            data1.module = this.selectedMainmoduleValue;
          }
          this.reportObj = { ...data1, ...data };
          this.appService.getDynamicGridData(data1).subscribe(
            {
              next:
                (response1: any) => {
                  this.documentTypeCall = response1;
                  this.visibleAuditTrail = false;
                  data1.columnsListarray = data1.columnsList.split(',');
                  data1.fieldColumnarray = data1.fieldLabelsList.split(',');
                  data1.invisibleColumnarray = data1.invisibleColumn.split(',');
                  data1.fieldSizeListArray = data1.fieldSizeList.split(',');

                  this.columnLists.columnsListarray = data1.columnsListarray;
                  this.columnLists.fieldLabelsList = data1.fieldLabelsList;
                  this.columnLists.fieldColumnarray = [];
                  for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                    this.columnLists.fieldColumnarray.push({
                      fieldColumnarray: data1.fieldColumnarray[p],
                      width: data1.fieldSizeListArray[p] + 'px',
                    });
                  }
                  this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
                  this.columnLists.fieldSizeListArray = [];

                  for (const size of data1.fieldSizeListArray) {
                    this.columnLists.fieldSizeListArray.push(size + 'px');
                  }

                  for (const invisibleCol of this.columnLists.invisibleColumnarray) {
                    const index = this.columnLists.columnsListarray.indexOf(invisibleCol);

                    if (index !== -1) {
                      this.columnLists.columnsListarray.splice(index, 1);
                      this.columnLists.fieldColumnarray.splice(index, 1);
                      this.columnLists.fieldSizeListArray.splice(index, 1);
                    }
                  }

                  let tableData = {
                    tablename: data1.tableOrViewName,
                  };
                  this.columnLists.columnsListarray1 = [];
                  this.appService
                    .tableFieldsDataType(tableData)
                    .subscribe((response2: any) => {
                      this.dataTypeList = response2;
                      for (
                        let m = 0;
                        m < this.columnLists.columnsListarray.length;
                        m++
                      ) {
                        this.columnLists.columnsListarray1.push({});
                        this.columnLists.columnsListarray1[m].columnsListarray =
                          this.columnLists.columnsListarray[m];
                        this.columnLists.columnsListarray1[m].dataType = 'textbox';
                        this.columnLists.columnsListarray1[m].width =
                          this.columnLists.fieldSizeListArray;
                        for (const dataType of this.dataTypeList) {
                          if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                            this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                          }
                        }
                      }
                      for (const docType of this.documentTypeCall) {
                        for (const dataType of this.dataTypeList) {
                          if (dataType.fieldType === 'CHECKBOX') {
                            docType[dataType.columnName] = docType[dataType.columnName] === 'Y';
                          }
                        }
                      }
                      this.calculateTotalPages = this.collectionSize / this.perPage;
                      this.pager.totalPages = undefined;
                      this.setPage(1, 0);
                      this.labelcall();
                    });
                  this.message.gridList = this.documentTypeCall;
                  this.collectionSize = this.documentTypeCall.length;
                }, error:
                (error) => {
                  this.isProcessing = false;
                  throw error;
                }
            }
          );
          this.isProcessing = false;
        }, error:
          (error) => {
            this.isProcessing = false;
            throw error;
          }
      }
    );
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next:
        (data: any) => {
          this.label = data;
          this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
            acc[`${user.columnName}`] = user.changedFieldName;
            return acc;
          }, {});
          console.log(this.dynamicLabel);
          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTypeCall.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = this.documentTypeCall.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  refreshGridData() {
    this.getcallMethod();
  }

  @ViewChild('addAndEditPopup', { static: true })
  addAndEditPopup: TemplateRef<any>;
  @ViewChild('notePopup', { static: true }) notePopup: TemplateRef<any>;
  @ViewChild('copyPopup', { static: true }) copyPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleNotePopup: MatDialogRef<TemplateRef<any>>;
  visibleCopyPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  notePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  copyPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  footerValidationIcon: any;
  waterValidationIcon: any;
  dropdownForHeaderReportTemplate: any = [];
  reportHeaderTemplateIds: any = [];
  openAddPopup() {
    this.selectedDownloadTemplate = null;
    this.visibleEditButton = false;
    this.popupTitle = 'Add Document Type';
    this.selectedmoduleValue = null;
    this.selectDocTypeName = [];
    this.selectFlexifieldsValue = [];
    this.selectCRProcess = null;
    this.selectedCrProcessValue = null;
    this.clearedPageContent = true;
    setTimeout(() => {
      this.isWithdrawListOfStagesSelected =
        this.obsoleteListOfStagesDropdown.length ==
        this.selectedObsoleteListOfStages.length;
    });
    setTimeout(() => {
      this.isExtnListOfStagesSelected =
        this.extensionListOfStagesDropdown.length ==
        this.selectedExtensionListOfStages.length;
    });

    setTimeout(() => {
      this.isExtnListOfStagesSelected =
        this.extensionListOfStagesDropdown.length ==
        this.selectedDestructionListOfStates.length;
    });

    setTimeout(() => {
      this.isPoAsdocumentTypesSelected =
        this.possibleAssDocDropdown.length ==
        this.selectedPossibleAssDoc.length;
    });
    setTimeout(() => {
      this.isListofFlexifieldsSelected =
        this.flexifieldsValueDropdown.length ==
        this.selectFlexifieldsValue.length;
    });
    setTimeout(() => {
      this.isListofStagesSelected =
        this.docTypeValueDropdown.length == this.selectDocTypeName.length;
    });

    if (this.modulevalue != null) {
      let data = this.dropDownForModules.filter(
        (x: any) => x.codelistCode === this.modulevalue
      );
      if (data.length > 0) {
        this.selectedmoduleValue = [
          {
            valueExp: this.modulevalue,
            displayExp: this.modulevalue,
          },
        ];
        this.selectModule = this.selectedmoduleValue.valueExp;
        this.selectModuleName = this.selectedmoduleValue.valueExp;
      }
    }
    this.selectedmoduleValue = this.selectedMainmoduleValue;
    this.modulevalue = this.selectedmoduleValue;
    this.possibleAssDocDropdown = [];
    for (const docType of this.documentTypeCall) {
      if (docType.IS_ASSOCIATED_DOCUMENT_TYPE) {
        this.possibleAssDocDropdown.push({
          valueExp: docType.DOCUMENT_TYPE_CODE,
          displayExp: docType.DOCUMENT_TYPE_NAME,
        });
      }
    }
    this.docTypeData = {};
    this.docTypeData = {
      documentTypeId: null,
      module: null,
      documentTypeName: null,
      documentTypeCode: null,
      listOfStages: null,
      isAssociatedDocumentType: false,
      isAmendmentDocType: false,
      extentionEnabled: false,
      destructionEnabled: false,
      belongsToIndividual: null,
      footerMessageFormat: null,
      watermarkMessageFormat: null,
      reminderExpiryBeforeNDays: null,
      remindEveryNDays: null,
      assignableAtTrainings: false,
      listOfFlexifields: null,
      printAdditionalPageAtDownload1: false,
      additionalPageName: null,
      additionalPagePrintPosition: null,
      additionalPageContent: null,
      documentTypeCodeForIdGeneration: null,
      isExpiryApplicable1: false,
      isActive: true,
      updateReason: null,
      deleteReason: null,
      expiryIn: '',
      documentTypeNameAtReports: null,
      documentTypeCodeAtReports: null,
      reportHeaderTemplateId: null,
    };
    this.selectedTemplate = null;
    this.selectedexpiryInUnit = null;
    this.selectedAmendmentListOfStages = [];
    this.selectedExtensionListOfStages = [];
    this.selectedDestructionListOfStates = [];
    this.selectedObsoleteListOfStages = [];
    this.selectedPossibleAssDoc = [];
    this.reportHeaderTemplateIds = [];
    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );
    if (this.modulevalue == 'DOCS' || this.modulevalue == 'TRN') {
      this.footerValidationIcon = document.getElementById(
        'footerMsg-val-icon'
      ) as HTMLInputElement;
      this.waterValidationIcon = document.getElementById(
        'waterMsg-val-icon'
      ) as HTMLInputElement;
      this.documentNameFormatValidationIcon = document.getElementById(
        'documentName-val-icon'
      ) as HTMLInputElement;
      this.footerValidationIcon.innerHTML =
        '<i class="fas fa-exclamation-circle"></i>';
      this.footerValidationIcon.style.color = 'green';
      this.waterValidationIcon.innerHTML =
        '<i class="fas fa-exclamation-circle"></i>';
      this.waterValidationIcon.style.color = 'green';
      this.documentNameFormatValidationIcon.innerHTML =
        '<i class="fas fa-exclamation-circle"></i>';
      this.documentNameFormatValidationIcon.style.color = 'green';
    }
  }

  editingDocumentTypeId: any;
  editPopup(data: any) {

    this.selectedTemplate = null;
    this.selectedexpiryInUnit = null;
    this.selectedmoduleValue = null;
    this.selectDocTypeName = [];
    this.selectFlexifieldsValue = [];
    this.selectedAmendmentListOfStages = [];
    this.selectedExtensionListOfStages = [];
    this.selectedDestructionListOfStates = [];
    this.selectedObsoleteListOfStages = [];
    this.selectCRProcess = null;
    this.selectedCrProcessValue = null;
    this.selectedPossibleAssDoc = [];
    this.editingDocumentTypeId = data.DOCUMENT_TYPE_ID;
    this.possibleAssDocDropdown = [];
    for (const docType of this.documentTypeCall) {
      if (docType.IS_ASSOCIATED_DOCUMENT_TYPE) {
        this.possibleAssDocDropdown.push({
          valueExp: docType.DOCUMENT_TYPE_CODE,
          displayExp: docType.DOCUMENT_TYPE_NAME,
        });
      }
    }
    this.docTypeData = {
      documentTypeId: data.DOCUMENT_TYPE_ID,
      module: data.MODULE,
      documentTypeName: data.DOCUMENT_TYPE_NAME,
      documentTypeCode: data.DOCUMENT_TYPE_CODE,
      listOfStages: data.LIST_OF_STAGES,
      isAssociatedDocumentType: data.IS_ASSOCIATED_DOCUMENT_TYPE,
      belongsToIndividual: data.BELONGS_TO_INDIVIDUAL,
      footerMessageFormat: data.FOOTER_MESSAGE_FORMAT,
      watermarkMessageFormat: data.WATERMARK_MESSAGE_FORMAT,
      reminderExpiryBeforeNDays: data.REMINDER_EXPIRY_BEFORE_N_DAYS,
      remindEveryNDays: data.REMIND_EVERY_N_DAYS,
      assignableAtTrainings: data.ASSIGNABLE_AT_TRAININGS,
      listOfFlexifields: data.LIST_OF_FLEXIFIELDS,
      possibleAssociatedDocumentTypes: data.POSSIBLE_ASSOCIATED_DOCUMENT_TYPES,
      isAmendementDocType: data.IS_AMENDEMENT_DOC_TYPE,
      extentionEnabled: data.EXTENTION_ENABLED,
      destructionEnabled: data.DESTRUCTION_ENABLED,
      isExpiryApplicable: data.IS_EXPIRY_APPLICABLE,
      amendmentListOfStages: data.AMENDMENT_LIST_OF_STAGES,
      extentionListOfStages: data.EXTENTION_LIST_OF_STAGES,
      withdrawlListOfStages: data.WITHDRAWL_LIST_OF_STAGES,
      documentTypeCodeForIdGeneration:
        data.DOCUMENT_TYPE_CODE_FOR_ID_GENERATION,
      allowedNoOfExtentions: data.AMENDMENT_LIST_OF_STAGES,
      expiryIn: data.EXTENTION_LIST_OF_STAGES,
      overrideEffectiveDate: data.OBSOLETE_LIST_OF_STAGES,
      overrideExpiryDate: data.DOCUMENT_TYPE_CODE_FOR_ID_GENERATION,
      printAdditionalPageAtDownload: data.PRINT_ADDITIONAL_PAGE_AT_DOWNLOAD,
      additionalPageName: data.ADDITIONAL_PAGE_NAME,
      additionalPageContent: data.ADDITIONAL_PAGE_CONTENT,
      additionalPagePrintPosition: data.ADDITIONAL_PAGE_PRINT_POSITION,
      isActive: data.IS_ACTIVE,
      isAutopublish: data.IS_AUTOPUBLISH,
      crProcess: data.CR_PROCESS,
      downloadedDocumentNameFormat: data.DOWNLOADED_DOCUMENT_NAME_FORMAT,
      updateReason: null,
      deleteReason: null,
      documentTypeNameAtReports: data.DOCUMENT_TYPE_NAME_AT_REPORTS,
      documentTypeCodeAtReports: data.DOCUMENT_TYPE_CODE_AT_REPORTS,
      reportHeaderTemplateId: data.REPORT_HEADER_TEMPLATE_ID,
    };
    this.appService
      .getDocumentTypeBasedOnDocTypeId(
        data.DOCUMENT_TYPE_ID
      )
      .subscribe((response: any) => {
        let data = response;
        if (data[0].downloadTemplateId) {
          this.selectedDownloadTemplate = Number(data[0].downloadTemplateId);
        } else {
          this.selectedDownloadTemplate = null;
        }
        this.docTypeData.allowedNoOfExtentions =
          data[0].allowedNoOfExtentions;
        this.docTypeData.expiryIn = data[0].expiryIn;
        this.docTypeData.isAssociatedDocumentType =
          data[0].isAssociatedDocumentType == 'Y';
        if (
          data[0].isAmendementDocType == 'Y' ||
          data[0].isAmendementEnabled == 'Y'
        ) {
          this.docTypeData.isAmendementDocType = true;
        }

        this.docTypeData.overrideEffectiveDate =
          data[0].overrideEffectiveDate == 'Y';
        this.docTypeData.overrideExpiryDate =
          data[0].overrideExpiryDate == 'Y';
        this.docTypeData.isExpiryApplicable =
          data[0].isExpiryApplicable == 'Y';
        this.docTypeData.printAdditionalPageAtDownload1 =
          data[0].printAdditionalPageAtDownload == 'Y';
        this.docTypeData.isExpiryApplicable1 =
          this.docTypeData.isExpiryApplicable;
        this.docTypeData.associatedDocToFollowSameExpiry =
          data[0].associatedDocToFollowSameExpiry == 'Y';
        (this.docTypeData.isBlindable =
          data[0].isBlindable == 'Y');
        (this.docTypeData.templateId = data[0].templateId);
        this.docTypeData.expiryInUnit = data[0].expiryInUnit;


        this.docTypeData.extensionListOfStages =
          data[0].extentionListOfStages;
        this.docTypeData.possibleAssociatedDocumentTypes =
          data[0].possibleAssociatedDocumentTypes;
        this.docTypeData.withdrawlListOfStages =
          data[0].withdrawalListOfStages;

        this.docTypeData.destructionListOfStates =
          data[0].destructionListOfStates;
        this.docTypeData.crProcess = data[0].crProcess;
        this.docTypeData.allowedNoOfAmendments =
          data[0].allowedNoOfAmendments;
        this.docTypeData.reportHeaderTemplateId =
          data[0].reportHeaderTemplateId;

        if (this.docTypeData.expiryInUnit) {
          const matchingExpiryUnit = this.dropDownForexpiryUnits?.find(
            (item: any) => item.codelistCode == this.docTypeData.expiryInUnit
          );
          if (!matchingExpiryUnit) {
            this.oddExpiryInUnit = this.docTypeData.expiryInUnit;
            this.expiryInUnitDropdown.push({
              valueExp: this.docTypeData.expiryInUnit,
              displayExp: this.docTypeData.expiryInUnit,
            });
          }
          this.selectedexpiryInUnit = this.docTypeData.expiryInUnit;
        }

        if (this.docTypeData.crProcess) {
          const matchingCRProcess = this.dataTypeCRProcess?.find(
            (item: any) => item.codelistCode == this.docTypeData.crProcess
          );
          if (!matchingCRProcess) {
            this.oddCRProcess = this.docTypeData.crProcess;
            this.CRProcessValueDropdown.push({
              valueExp: this.docTypeData.crProcess,
              displayExp: this.docTypeData.crProcess,
            });
          }
          this.selectCRProcess = this.docTypeData.crProcess;
        }


        if (this.docTypeData.templateId) {
          const matchingTemplate = this.dropDownForTemplates?.find(
            (item: any) => item.templateId == this.docTypeData.templateId
          );

          if (!matchingTemplate) {
            this.oddTemplate = this.docTypeData.templateId;
            let cleanName = response[0].templateName;

            if (cleanName) {
              if (cleanName.lastIndexOf(',') > 0) {
                cleanName = cleanName.substring(0, cleanName.lastIndexOf(','));
              }
              else if (cleanName.lastIndexOf('.') > 0) {
                cleanName = cleanName.substring(0, cleanName.lastIndexOf('.'));
              }
            }
            this.TemplateDropdown.push({
              valueExp: this.docTypeData.templateId,
              displayExp: cleanName,
            });
          }
          this.selectedTemplate = this.docTypeData.templateId;
        }

        if (response[0].additionalPageContent) {
          this.pageContent = response[0].additionalPageContent;
          this.docTypeData.additionalPageContent =
            response[0].additionalPageContent;
          this.clearedPageContent = false;
        } else {
          this.pageContent = null;
          this.clearedPageContent = true;
        }
        this.docTypeData.additionalPageName = response[0].additionalPageName;
        this.docTypeData.additionalPagePrintPosition =
          response[0].additionalPagePrintPosition;
        if (this.docTypeData.withdrawlListOfStages) {
          this.selectedObsoleteListOfStages =
            this.docTypeData.withdrawlListOfStages.split(',');
          setTimeout(() => {
            this.isWithdrawListOfStagesSelected =
              this.obsoleteListOfStagesDropdown.length ==
              this.selectedObsoleteListOfStages.length;
            this.docTypeData.withdrawlListOfStages.split(',').length ==
              this.docWithdrawlStageList.length &&
              this.withdrawListOfStages.options.forEach((item: MatOption) =>
                item.select()
              );
          });
        }


        if (this.docTypeData.possibleAssociatedDocumentTypes) {
          this.selectedPossibleAssDoc =
            this.docTypeData.possibleAssociatedDocumentTypes.split(',');
          setTimeout(() => {
            this.isPoAsdocumentTypesSelected =
              this.possibleAssDocDropdown.length ==
              this.selectedPossibleAssDoc.length;
            this.docTypeData.possibleAssociatedDocumentTypes.split(',')
              .length == this.documentTypeCall.length &&
              this.poAsdocumentTypes.options.forEach((item: MatOption) =>
                item.select()
              );
          });
        }


        if (this.docTypeData.extensionListOfStages) {
          this.selectedExtensionListOfStages =
            this.docTypeData.extensionListOfStages.split(',');
          setTimeout(() => {
            this.isExtnListOfStagesSelected =
              this.extensionListOfStagesDropdown.length ==
              this.selectedExtensionListOfStages.length;
            this.docTypeData.extensionListOfStages.split(',').length ==
              this.docExtensionStageList.length &&
              this.extnListOfStages.options.forEach((item: MatOption) =>
                item.select()
              );
          });
        }

        if (this.docTypeData.destructionListOfStates) {
          this.selectedDestructionListOfStates =
            this.docTypeData.destructionListOfStates.split(',');
          setTimeout(() => {
            this.destructionListOfStatesSelected =
              this.destructionListOfStatesDropdown.length ==
              this.selectedDestructionListOfStates.length;
            this.docTypeData.destructionListOfStates.split(',').length ==
              this.docDestructionListOfStatesList.length &&
              this.destructionListOfStates.options.forEach((item: MatOption) =>
                item.select()
              );
          });
        }


      });
    this.visibleEditButton = true;
    this.popupTitle = 'Edit Document Type';

    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );


    if (this.docTypeData.module) {
      const matchingModule = this.dropDownForModules?.find(
        (item: any) => item.codelistCode == this.docTypeData.module
      );
      if (!matchingModule) {
        this.oddModuleValue = this.docTypeData.module;
        this.moduleValueDropdown.push({
          valueExp: this.docTypeData.module,
          displayExp: this.docTypeData.module,
        });
      }
      this.selectedmoduleValue = this.docTypeData.module;
    }

    if (this.docTypeData.reportHeaderTemplateId) {
      const matchingTemplate = this.dropDownForReportHeaderTemplateId?.find(
        (item: any) => item.templateId == this.docTypeData.templateId
      );
      console.log(matchingTemplate);
      if (!matchingTemplate) {
        this.oddReportHeaderTemplateId = this.docTypeData.templateId;
        if (this.docTypeData.templateId != undefined) {
          this.dropdownForHeaderReportTemplate.push({
            valueExp: this.docTypeData.templateId,
            displayExp: this.docTypeData.templateId,
          });
        }
      }
      setTimeout(() => {
        this.reportHeaderTemplateId = Number(
          this.docTypeData.reportHeaderTemplateId
        );
      });
    }


    if (this.docTypeData.listOfStages) {
      this.selectDocTypeName = this.docTypeData.listOfStages.split(',');
      setTimeout(() => {
        this.isListofStagesSelected =
          this.docTypeValueDropdown.length == this.selectDocTypeName.length;
        this.docTypeData.listOfStages.split(',').length ==
          this.flexifieldSetupList.length &&
          this.listofFlexifields.options.forEach((item: MatOption) =>
            item.select()
          );
      });
    }

    if (this.docTypeData.amendmentListOfStages) {
      const amendmentArrayValue = this.docTypeData.amendmentListOfStages.split(',');
      this.selectedAmendmentListOfStages = [];

      for (const stage of amendmentArrayValue) {
        this.selectedAmendmentListOfStages.push({
          valueExp: stage,
          displayExp: stage,
        });
      }
    }


    if (this.docTypeData.listOfFlexifields) {
      this.selectFlexifieldsValue = this.docTypeData.listOfFlexifields
        .split(',')
        .map(Number);
      setTimeout(() => {
        this.isListofFlexifieldsSelected =
          this.flexifieldsValueDropdown.length ==
          this.selectFlexifieldsValue.length;
        this.docTypeData.listOfFlexifields.split(',').length ==
          this.flexifieldSetupList.length &&
          this.listofFlexifields.options.forEach((item: MatOption) =>
            item.select()
          );
      });
    }

    if (this.modulevalue == 'DOCS' || this.modulevalue == 'TRN') {
      this.footerValidationIcon = document.getElementById(
        'footerMsg-val-icon'
      ) as HTMLInputElement;
      this.waterValidationIcon = document.getElementById(
        'waterMsg-val-icon'
      ) as HTMLInputElement;
      this.documentNameFormatValidationIcon = document.getElementById(
        'documentName-val-icon'
      ) as HTMLInputElement;
      const el = document.getElementById('footerValidationIcon');
      if (el) {
        el.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
        this.footerValidationIcon.style.color = 'green';
      }
      const e2 = document.getElementById('waterValidationIcon');
      if (e2) {
        this.waterValidationIcon.innerHTML =
          '<i class="fas fa-exclamation-circle"></i>';
        this.waterValidationIcon.style.color = 'green';
      }
      const e3 = document.getElementById('documentNameFormatValidationIcon');
      if (e3) {
        this.documentNameFormatValidationIcon.innerHTML =
          '<i class="fas fa-exclamation-circle"></i>';
        this.documentNameFormatValidationIcon.style.color = 'green';
      }
    }
  }

  updateReasonValidation() {
    const updateReason = document.getElementById(
      'updateReason'
    ) as HTMLInputElement;
    const updateReasonRequiredMsg = document.getElementById(
      'updateReason-required-msg'
    ) as HTMLInputElement;
    if (this.docTypeData.updateReason == null) {
      updateReason.style.border = '1px solid red';
      updateReasonRequiredMsg.style.display = 'block';
    } else {
      updateReason.style.border = 'none';
      updateReasonRequiredMsg.style.display = 'none';
    }
  }

  documentTypeNameValue: any;
  documentTypeCodeValue: any;
  destructionListOfStatesValue: any;
  destructionListOfStatesFocus: any;
  documentTypeNameRequiredMsg: any;
  documentTypeCodeRequiredMsg: any;
  expiryUnit: any;
  expiryUnitReqdMsg: any;
  expiryInInput: HTMLElement | null = null;
  expiryInReqMsg: HTMLElement | null = null;
  expiryUnitSelect: HTMLElement | null = null;
  expiryUnitReqMsg: HTMLElement | null = null;
  focusEmpty() {
    console.log();
  }
  fieldValidation() {
    this.documentTypeNameValue = document.getElementById('documentTypeName') as HTMLInputElement;
    this.documentTypeNameRequiredMsg = document.getElementById('documentTypeName-required-msg') as HTMLInputElement;

    this.documentTypeCodeValue = document.getElementById('documentTypeCode') as HTMLInputElement;
    this.documentTypeCodeRequiredMsg = document.getElementById('documentTypeCode-required-msg') as HTMLInputElement;

    this.destructionListOfStatesFocus = document.getElementById('destructionListOfStatesfocus') as HTMLInputElement;

    this.expiryInInput = document.getElementById('expiryInInput');
    this.expiryInReqMsg = document.getElementById('expiryin-required-msg');
    this.expiryUnitSelect = document.getElementById('expiryUnitSelect');
    this.expiryUnitReqMsg = document.getElementById('expiryUnit-required-msg');

    const setValidationStyles = (element: HTMLElement | null, msgElement: HTMLElement | null, isValid: boolean) => {
      if (element) {
        element.style.border = isValid ? 'none' : '1px solid red';
      }
      if (msgElement) {
        msgElement.style.display = isValid ? 'none' : 'block';
      }
    };

    const isExpiryValid = !this.docTypeData.isExpiryApplicable1;
    const hasExpiryIn = isExpiryValid || !!this.docTypeData.expiryIn;
    const hasExpiryUnit = isExpiryValid || !!this.selectedexpiryInUnit;

    setValidationStyles(this.expiryInInput, this.expiryInReqMsg, hasExpiryIn);
    setValidationStyles(this.expiryUnitSelect, this.expiryUnitReqMsg, hasExpiryUnit);

    setValidationStyles(
      this.documentTypeNameValue,
      this.documentTypeNameRequiredMsg,
      !!this.documentTypeNameValue?.value
    );

    setValidationStyles(
      this.documentTypeCodeValue,
      this.documentTypeCodeRequiredMsg,
      !!this.documentTypeCodeValue?.value
    );

    setValidationStyles(
      this.destructionListOfStatesFocus,
      null,
      !!this.selectedDestructionListOfStates
    );
  }
  selectedCrProcessValue: any = null;
  crProcessSearchTxt: any;

  onCrprocessSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCRProcess = item.valueExp;
      } else {
        this.selectCRProcess = null;
      }
    }
  }

  expirysearchTxt: any;
  templatesearchTxt: any;
  additionalPagePrintsearchTxt: any;
  addAndEditFunction(documentData: any) {
    if (documentData.isAssociatedDocumentType) {
      this.selectedPossibleAssDoc = [];
      this.docTypeData.associatedDocToFollowSameExpiry = false;
      this.docTypeData.allowedNoOfAmendments = null;
    }

    if (!documentData.isAmendementDocType) {
      this.docTypeData.allowedNoOfAmendments = null;
    }

    if (!documentData.extentionEnabled) {
      this.docTypeData.allowedNoOfExtentions = null;
      this.selectedExtensionListOfStages = [];
    }

    if (!documentData.destructionEnabled) {
      this.selectedDestructionListOfStates = [];
    }

    if (!documentData.isExpiryApplicable1) {
      this.docTypeData.expiryIn = null;
      this.selectedexpiryInUnit = null;
    }

    if (!documentData.printAdditionalPageAtDownload1) {
      this.docTypeData.additionalPageName = null;
      this.docTypeData.additionalPagePrintPosition = null;
      this.pageContent = null;
      this.docTypeData.additionalPageContent = null;
    }
    const selectedTemplate = this.getSelectedDownloadTemplate();
    console.log(documentData.destructionEnabled + "======" + this.selectedDestructionListOfStates);
    if (
      !this.docTypeData.documentTypeName ||
      !this.docTypeData.documentTypeCode ||
      (this.docTypeData.isExpiryApplicable1 && (!this.docTypeData.expiryIn || !this.selectedexpiryInUnit)) ||
      (documentData.printAdditionalPageAtDownload1 &&
        (!this.docTypeData.additionalPageName ||
          !this.pageContent ||
          !documentData.additionalPagePrintPosition)) ||
      (documentData.destructionEnabled &&
        (this.selectedDestructionListOfStates == "" || this.selectedDestructionListOfStates == null || this.selectedDestructionListOfStates == 'undefined'))
    ) {
      this.fieldValidation();
      this.showSnackBar('Please enter all mandatory fields', 'E');
    } else {
      this.isProcessing = true;
      let tempdata = {

        module: this.selectedmoduleValue ?? null,
        expiryInUnit: this.selectedexpiryInUnit ?? null,
        crProcess: this.selectCRProcess,
        templateId: this.selectedTemplate ?? null,
        downloadTemplateId: selectedTemplate?.id ?? null,
        documentTemplateName: selectedTemplate?.name ?? null,
        listOfStages: this.selectDocTypeName.join(','),
        listOfFlexifields: this.selectFlexifieldsValue.map(String).join(','),
        amendmentListOfStages: this.selectedAmendmentListOfStages.join(','),
        extentionListOfStages: this.selectedExtensionListOfStages.join(','),
        withdrawalListOfStages: this.selectedObsoleteListOfStages.join(','),
        destructionListOfStates: this.selectedDestructionListOfStates.join(','),
        possibleAssociatedDocumentTypes: this.selectedPossibleAssDoc.join(','),
        reportHeaderTemplateId: this.reportHeaderTemplateId ?? null,
        isAssociatedDocumentType: documentData.isAssociatedDocumentType
          ? 'Y'
          : 'N',
        belongsToIndividual: documentData.belongsToIndividual ? 'Y' : 'N',
        assignableAtTrainings: documentData.assignableAtTrainings ? 'Y' : 'N',
        isActive: documentData.isActive ? 'Y' : 'N',
        isAutopublish: documentData.isAutopublish ? 'Y' : 'N',
        isAmendementDocType: documentData.isAmendementDocType ? 'Y' : 'N',
        isExpiryApplicable: documentData.isExpiryApplicable1 ? 'Y' : 'N',
        extentionEnabled: documentData.extentionEnabled ? 'Y' : 'N',
        destructionEnabled: documentData.destructionEnabled ? 'Y' : 'N',
        overrideExpiryDate: documentData.overrideExpiryDate ? 'Y' : 'N',
        overrideEffectiveDate: documentData.overrideEffectiveDate ? 'Y' : 'N',
        isBlindable: documentData.isBlindable ? 'Y' : 'N',
        associatedDocToFollowSameExpiry:
          documentData.associatedDocToFollowSameExpiry ? 'Y' : 'N',
        printAdditionalPageAtDownload:
          documentData.printAdditionalPageAtDownload1 ? 'Y' : 'N',
      };

      let data = { ...this.docTypeData, ...tempdata };
      console.log('data=', data);
      const formData = new FormData();
      formData.append('file', this.pageContent);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json',
      });
      formData.append('oneQmsDocumentTypesVwDto', blob);
      if (this.visibleEditButton) {
        if (this.docTypeData.updateReason) {
          let modifiedData = {
            ...data,
            documentTypeId: this.editingDocumentTypeId,
          };
          const formData = new FormData();
          formData.append('file', this.pageContent);
          const json = JSON.stringify(modifiedData);
          const blob = new Blob([json], {
            type: 'application/json',
          });
          formData.append('oneQmsDocumentTypesVwDto', blob);
          this.appService.updateoneQmsDocumentTypes(formData).subscribe({
            next:
              (Response: any) => {
                if (Response.resultType == 'S') {
                  this.visibleAddAndEditPopup.close();
                  this.getcallMethod();
                }
                this.isProcessing = false;
                let sb = this.snackBar.openFromComponent(
                  SuccessSnackbarComponent,
                  {
                    duration: Response.resultType == 'S' ? 5000 : undefined,
                    data: {
                      message: Response.result,
                      type: Response.resultType == 'S' ? 'Success' : 'Error',
                      buttonLabel: 'Ok',
                      pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,

                    },
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
                  }
                );
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
                this.isProcessing = false;
              }, error:
              (error) => {
                this.isProcessing = false;
                throw error;
              }
          }
          );
        } else {
          this.updateReasonValidation();
          this.isProcessing = false;
        }
      } else {
        this.appService.createoneQmsDocumentTypes(formData).subscribe({
          next:
            (Response: any) => {
              if (Response.resultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.getcallMethod();
              }
              this.isProcessing = false;
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: Response.resultType == 'S' ? 5000 : undefined,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: 'Ok',
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            }, error:
            (error) => {
              this.isProcessing = false;
              throw error;
            }
        }
        );
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deleteCodelistPopop(data: any) {
    this.docTypeData = {
      documentTypeId: data.DOCUMENT_TYPE_ID,
      module: data.MODULE,
      documentTypeName: data.DOCUMENT_TYPE_NAME,
      documentTypeCode: data.DOCUMENT_TYPE_CODE,
      listOfStages: data.LIST_OF_STAGES,
      isAssociatedDocumentType: data.IS_ASSOCIATED_DOCUMENT_TYPE,
      belongsToIndividual: data.BELONGS_TO_INDIVIDUAL,
      footerMessageFormat: data.FOOTER_MESSAGE_FORMAT,
      watermarkMessageFormat: data.WATERMARK_MESSAGE_FORMAT,
      reminderExpiryBeforeNDays: data.REMINDER_EXPIRY_BEFORE_N_DAYS,
      remindEveryNDays: data.REMIND_EVERY_N_DAYS,
      assignableAtTrainings: data.ASSIGNABLE_AT_TRAININGS,
      listOfFlexifields: data.LIST_OF_FLEXIFIELDS,
      isActive: data.IS_ACTIVE,
      isAutopublish: data.isAutopublish,
      updateReason: null,
      deleteReason: null,
    };
    this.popupTitle = 'Delete Document Type';
    this.deleteReason = null;
    this.visibleDeletePopup = this.dialog.open(
      this.deletePopup,
      this.deletePopupConfig
    );
  }

  deleteReasonValue: any;
  deleteValidation() {
    const deleteReasonValue = document.getElementById(
      'deleteReason'
    ) as HTMLInputElement;
    const deleteReasonRequiredMsg = document.getElementById(
      'deleteReason-required-msg'
    ) as HTMLInputElement;
    if (this.deleteReason == null) {
      deleteReasonValue.style.border = '1px solid red';
      deleteReasonRequiredMsg.style.display = 'block';
    } else {
      deleteReasonValue.style.border = 'none';
      deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteReason: any = null;
  deleteFunction() {
    if (this.deleteReason == null) {
      this.deleteValidation();
    } else {
      this.isProcessing = true;
      this.docTypeData.deleteReason = this.deleteReason;
      let data: any = this.docTypeData;
      console.log(this.docTypeData);
      data.isAssociatedDocumentType = this.docTypeData.isAssociatedDocumentType
        ? 'Y'
        : 'N';
      data.belongsToIndividual = this.docTypeData.belongsToIndividual
        ? 'Y'
        : 'N';
      data.assignableAtTrainings = this.docTypeData.assignableAtTrainings
        ? 'Y'
        : 'N';
      data.isActive = this.docTypeData.isActive ? 'Y' : 'N';
      data.isAutopublish = this.docTypeData.isAutopublish ? 'Y' : 'N';
      data.isAmendmentDocType = this.docTypeData.isAmendmentDocType ? 'Y' : 'N';
      data.extentionEnabled = this.docTypeData.extentionEnabled ? 'Y' : 'N';
      data.destructionEnabled = this.docTypeData.destructionEnabled ? 'Y' : 'N';
      data.overrideExpiryDate = this.docTypeData.overrideExpiryDate ? 'Y' : 'N';
      data.overrideEffectiveDate = this.docTypeData.overrideEffectiveDate
        ? 'Y'
        : 'N';
      data.isBlindable = this.docTypeData.isBlindable ? 'Y' : 'N';
      data.associatedDocToFollowSameExpiry = this.docTypeData
        .associatedDocToFollowSameExpiry
        ? 'Y'
        : 'N';
      data.printAdditionalPageAtDownload = this.docTypeData
        .printAdditionalPageAtDownload1
        ? 'Y'
        : 'N';
      this.appService.deleteoneQmsDocumentTypes(this.docTypeData).subscribe({
        next:
          (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleDeletePopup.close();
              this.getcallMethod();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: Response.resultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok',
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,

              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error:
          (error) => {
            this.isProcessing = false;
            throw error;
          }
      }
      );
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  infoMsg(val: any) {
    let footerValidationIcon = document.getElementById(
      'footerMsg-val-icon'
    ) as HTMLInputElement;
    let footerMsg = document.getElementById('footerMsg') as HTMLInputElement;
    footerValidationIcon.innerHTML =
      '<i class="fas fa-exclamation-circle"></i>';
    if (val) {
      footerValidationIcon.style.color = 'green';
      footerMsg.style.width = '90%';
    } else {
      footerValidationIcon.style.color = 'none';
      footerMsg.style.width = '100%';
    }
  }

  clickToGetNote() {
    this.visibleNotePopup = this.dialog.open(
      this.notePopup,
      this.notePopupConfig
    );
  }

  cancelNote() {
    this.visibleNotePopup.close();
  }

  copyDocumentTypeData: any = {};
  copyPopupFunc(data: any) {
    this.copyDocumentTypeData = {};
    this.copyDocumentTypeData.documentTypeName = '';
    this.copyDocumentTypeData.documentTypeCode = '';
    this.copyDocumentTypeData.documentTypeId = data.DOCUMENT_TYPE_ID;
    this.visibleCopyPopup = this.dialog.open(
      this.copyPopup,
      this.copyPopupConfig
    );
  }

  cancelCopyFunction() {
    this.visibleCopyPopup.close();
  }

  documentTypeNameCopyValue: any;
  documentTypeCodeCopyValue: any;
  documentTypeNameCopyRequiredMsg: any;
  documentTypeCodeCopyRequiredMsg: any;
  fieldValidationForCopy() {
    this.documentTypeNameCopyValue = document.getElementById(
      'documentTypeNameForCopy'
    ) as HTMLInputElement;
    this.documentTypeNameCopyRequiredMsg = document.getElementById(
      'documentTypeNameForCopy-required-msg'
    ) as HTMLInputElement;

    this.documentTypeCodeCopyValue = document.getElementById(
      'documentTypeCodeForCopy'
    ) as HTMLInputElement;
    this.documentTypeCodeCopyRequiredMsg = document.getElementById(
      'documentTypeCodeForCopy-required-msg'
    ) as HTMLInputElement;

    if (this.documentTypeNameCopyValue.value) {
      this.documentTypeNameCopyValue.style.border = 'none';
      this.documentTypeNameCopyRequiredMsg.style.display = 'none';
    } else {
      this.documentTypeNameCopyValue.style.border = '1px solid red';
      this.documentTypeNameCopyRequiredMsg.style.display = 'block';
    }
    if (this.documentTypeCodeCopyValue.value) {
      this.documentTypeCodeCopyValue.style.border = 'none';
      this.documentTypeCodeCopyRequiredMsg.style.display = 'none';
    } else {
      this.documentTypeCodeCopyValue.style.border = '1px solid red';
      this.documentTypeCodeCopyRequiredMsg.style.display = 'block';
    }
  }

  copyFunction() {
    this.isProcessing = true;

    const code = this.copyDocumentTypeData.documentTypeCode || '';

    if (
      this.copyDocumentTypeData.documentTypeName.trim() === '' ||
      code.trim() === ''
    ) {
      this.fieldValidationForCopy();
      this.isProcessing = false;
      return;
    }

    // Validation for dot (.) or leading/trailing spaces
    if (code.includes('.') || code.trim() !== code) {
      this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: `Avoid dot(.) or empty space(' ') at document type code. - Document type '${this.copyDocumentTypeData.documentTypeName}' creation failed.`,
          type: 'Error',
          buttonLabel: 'Ok',
          pageName:
            this.message.breadcrumbData.thirdLevel ??
            this.message.breadcrumbData.secondLevel,
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error',
      });
      this.isProcessing = false;
      return;
    }

    // Proceed with API call if validation passes
    this.appService.copyDocumentTypes(this.copyDocumentTypeData).subscribe({
      next:
        (data: any) => {
          if (data.resultType === 'S') {
            this.visibleCopyPopup.close();
            this.getcallMethod();
          }

          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: data.resultType === 'S' ? 5000 : undefined,
            data: {
              message: data.result,
              type: data.resultType === 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok',
              pageName:
                this.message.breadcrumbData.thirdLevel ??
                this.message.breadcrumbData.secondLevel,
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType === 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

          this.isProcessing = false;
        }, error:
        (error) => {
          this.isProcessing = false;
          throw error;
        }
    }
    );
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTypeCall.sort(
      (a: { [x: string]: any }, b: { [x: string]: any }) => {
        const key = column;
        const valueA = a[key];
        const valueB = b[key];

        if (valueA! < valueB!) {
          return this.sortDirection === 'asc' ? -1 : 1;
        } else if (valueA! > valueB!) {
          return this.sortDirection === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
    );
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent)
  dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo =
      viewType == 'overAll' ? null : notification.DOCUMENT_TYPE_ID;
    this.auditTrail.gridName = 'DOCUMENT_TYPES';
    this.auditTrail.report_And_Popup_Name = 'Document Types Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Document Type Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map(
      (item: any) => item.fieldColumnarray
    );
    this.excelPdfComponent.openReportPopup(reportType);
  }

  validateCodeFields(event: KeyboardEvent) {
    const forbiddenKeys = ['.', ' '];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  sanitizeInput(event: any) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replaceAll(/[\s.]/g, '');

    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
      this.docTypeData.documentTypeCode = sanitizedValue;
      this.copyDocumentTypeData.documentTypeCode = sanitizedValue;
    }
  }

  onPasteSanitizeCopyCode(event: ClipboardEvent) {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') ?? '';
    const sanitized = pasted.replaceAll(/[\s.]/g, '');

    this.copyDocumentTypeData.documentTypeCode =
      (this.copyDocumentTypeData.documentTypeCode ?? '') + sanitized;
  }


  sanitizeCopyCode(event: Event) {
    const input = event.target as HTMLInputElement;

    const sanitizedValue = (input.value || '').replaceAll(/[\s.]/g, '');

    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
    }
    this.copyDocumentTypeData.documentTypeCode = sanitizedValue;
  }


  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(
      this.reportObj.gridName,
      this.reportObj.tableOrViewName,
      null,
      0
    );
  }

  onChildValueEmitted() {
    this.getcallMethod();
  }

  clearedPageContent: any;
  pageContent: any;

  removePageContent() {
    this.clearedPageContent = true;
    this.pageContent = null;
    this.docTypeData.additionalPageContent = null;
  }

  @ViewChild('fileUpload')
  myInputVariable: ElementRef;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.pageContent = file;
      let fileName = file.name;
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      if (extension == 'pdf') {
        const formData = new FormData();
        formData.append('file', file ?? '');
        formData.append('pageName', 'DMS');
        formData.append('fileName', fileName);
        formData.append('extension', extension);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType !== 'S') {
              this.myInputVariable.nativeElement.value = '';
              this.pageContent = null;
              this.docTypeData.additionalPageContent = null;
              let sb = this.snackBar.openFromComponent(
                SuccessSnackbarComponent,
                {
                  duration: 5000,
                  data: {
                    message: data.result,
                    type: data.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: 'Ok',
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                }
              );
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error:
            (error) => {
              this.myInputVariable.nativeElement.value = '';
              this.isProcessing = false;
              throw error;
            }
        }
        );
      } else {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: 'The file should be in pdf format',
            type: 'Error',
            buttonLabel: 'Ok',
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.myInputVariable.nativeElement.value = '';
      }
    } else {
      this.pageContent = null;
      this.docTypeData.additionalPageContent = null;
    }
  }
  toggle(event: any) {
    if (!event.checked) {
      this.docTypeData.additionalPageName = null;
      this.docTypeData.additionalPagePrintPosition = null;
      this.pageContent = null;
      this.docTypeData.additionalPageContent = null;
    }
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(
      SuccessSnackbarComponent,
      {
        duration: type === 'S' ? 5000 : undefined,
        data: {
          message,
          type: type === 'S' ? 'Success' : 'Error',
          buttonLabel: 'Ok',
          pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,

        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: type === 'S' ? 'Success' : 'Error',
      }
    );

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { },
    });
  }
  gridTemp: any[] = [];
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.gridTemp = this.documentTypeCall;
      this.pager = this.paginationService.getPager(
        this.gridTemp.length,
        1,
        this.perPage,
        0
      );
      this.pagedItems = this.gridTemp.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      if (this.documentTypeCall == undefined) {
        return;
      }
      if (!this.documentTypeCall.length) {
        return;
      }
      if (filter) {
        this.gridTemp = this.documentTypeCall.filter((item: any) => {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.documentTypeCall.filter((item: any) => {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(
        this.gridTemp.length,
        page,
        this.perPage,
        targetPage
      );
      this.pagedItems = this.gridTemp.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = [];
    }
  }


  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  downloadTemplates(list: any, columnName: any) {
    this.isProcessing = true;

    const docObj = {

      documentTypeId: list.DOCUMENT_TYPE_ID,
      refNo: list.REF_NO,
      documentName: list.DOCUMENT_NAME,
      documentType: list.DOCUMENT_TYPE,
      documentExtn: list.DOCUMENT_EXTN
    };

    this.appService.viewAdditionalPageContentFile(

      docObj.documentTypeId,
      docObj.documentName
    ).subscribe((response: any) => {
      this.isProcessing = false;

      if (response.status === 200) {
        const contentType = response.headers.get('content-type');
        const blob = new Blob([response.body], { type: contentType });
        const doc = { body: response.body, contentType, extn: list.DOCUMENT_EXTN };

        this.docViewer = {
          blob,
          doc,
          docName: 'list.ADDITIONAL_PAGE_NAME',
          docExtension: 'pdf',
        };

        // Wait for component to render
        setTimeout(() => {
          this.documentViewerComponent?.openPopUp();
        });
      } else {
        alert("Error Occurred: " + response.status);
      }
    });
  }


}
